<template>
  <button type="button" class="ui-toggle" :aria-pressed="String(pressed)" v-on="$listeners">
    <slot></slot>
  </button>
</template>

<script>
/** Izbor-oznaka (filter): uključen kad je `pressed`. Klik javlja roditelju (@click), koji mijenja stanje. */
export default {
  name: "UiToggle",
  props: { pressed: { type: Boolean, default: false } },
};
</script>
